<template>
  <simple-button
    :class="{
      'interactive-button__button': true,
      'interactive-button__button--inactive': disabled
    }"
    :disabled="disabled"
    :text="label"
  >
  </simple-button>
</template>

<script>
import SimpleButton from './SimpleButton'

export default {
  components: {
    SimpleButton
  },
  props: {
    label: {
      type: String,
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style lang="scss">
.interactive-button {
  &__button {
    margin: 25px auto 0 auto;
    background: black;
  }

  &__button--inactive {
    background: rgb(198, 204, 209);
    cursor: default;
  }

  &__button--inactive:hover {
    color: white;
  }
}
</style>



// WEBPACK FOOTER //
// InteractiveSimpleButton.vue?3526eeab